import { useUiLanguage } from '../hooks';

export const stringOrUndefined2Num = (str?: string, defaultVal = 0): number => {
    const val = Number(str);
    if (isNaN(val)) {
        return defaultVal;
    }

    return val;
};

export const stringOrUndefined2NumOrUndefined = (str?: string, defaultVal = 0): number | undefined => {
    if (typeof str === 'undefined' || str === null) {
        return undefined;
    } else {
        return stringOrUndefined2Num(str, defaultVal);
    }
};

export const string2number = (value: string | number | undefined | null): number | null =>
    typeof value === 'string'
        ? isNaN(parseFloat(value))
            ? null
            : parseFloat(value)
        : typeof value === 'undefined'
        ? null
        : value;

export const toNum = (value: string | number | undefined | null): number | undefined => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }

    const num = Number(value);

    return Number.isNaN(num) ? undefined : num;
};

export const showPrice = (price: number | string | undefined, currency = ''): string => {
    if (price === undefined) {
        return '';
    }
    const numPrice = typeof price === 'number' ? price : parseFloat(price);
    if (isNaN(numPrice)) {
        return '';
    }
    return `${numPrice.toFixed(2)} ${currency}`;
};

export const n0u2n = (value: number | undefined): number => {
    return value ?? 0;
};

export const numberToStringWithSeparator = (n: number | string | undefined, decimal = 0, location = 'fr'): string => {
    if (!n) {
        return '0';
    }
    let num: number;
    if (typeof n === 'string') {
        num = parseFloat(n);
    } else {
        num = n;
    }
    return num.toLocaleString(location, {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
    });
};

type IUseNumber = {
    numberToString: (n: number, decimal?: number, location?: string) => string;
};
export const useNumber = (): IUseNumber => {
    const languageId = useUiLanguage();
    const numberToString = (n: number, decimal = 0) => numberToStringWithSeparator(n, decimal, languageId);

    return { numberToString };
};
export const num2Fix2 = (n: number | string | undefined): string => {
    if (!n) {
        return '0';
    }
    let num: number;
    if (typeof n === 'string') {
        num = parseFloat(n);
    } else {
        num = n;
    }
    return num.toFixed(2);
};
